import i18n from './i18n';

const kinds = {
  'multiple-choice': {
    kind: 'multiple-choice',
    multiple_answers: false,
    title: i18n.step_kinds.kinds.multiple_choise.title,
    description_text: i18n.step_kinds.kinds.multiple_choise.description_text,
    description_visibility: true,
    position: 0,
  },
  'yes-no': {
    kind: 'yes-no',
    title: i18n.step_kinds.kinds.yes_no.title,
    description_text: i18n.step_kinds.kinds.yes_no.description_text,
    description_visibility: true,
    position: 0,
  },
  text: {
    kind: 'text',
    title: i18n.step_kinds.kinds.text.title,
    description_text: i18n.step_kinds.kinds.text.description_text,
    description_visibility: false,
    required: true,
    text_size: 'short',
    placeholder_text: i18n.step_kinds.kinds.text.placeholder,
    position: 0,
  },
  email: {
    kind: 'email',
    title: i18n.step_kinds.kinds.email.title,
    description_text: i18n.step_kinds.kinds.email.description_text,
    description_visibility: false,
    redirect_email_service: true,
    form_html: '',
    position: 0,
  },
  redirect: {
    kind: 'redirect',
    title: i18n.step_kinds.kinds.redirect.title,
    description_text: i18n.step_kinds.kinds.redirect.description_text,
    description_visibility: false,
    redirect_automatic: false,
    redirect_button_text: i18n.step_kinds.kinds.redirect.button_text,
    redirect_url: 'http://klickpages.com.br',
    final: true,
    position: 0,
  },
  thanks: {
    kind: 'thanks',
    title: i18n.step_kinds.kinds.thanks.title,
    description_text: i18n.step_kinds.kinds.thanks.description_text,
    description_visibility: true,
    final: true,
    position: 0,
  },
};

const options = {
  'multiple-choice': [
    { label: i18n.step_kinds.options.multiple_choise.first_option },
    { label: i18n.step_kinds.options.multiple_choise.second_option },
  ],
  'yes-no': [
    { label: i18n.step_kinds.options.yes_no.yes },
    { label: i18n.step_kinds.options.yes_no.no },
  ],
  email: [],
  redirect: [],
  thanks: [],
};

export default {
  generate(step) {
    return Object.assign({}, step, kinds[step.kind]);
  },

  getOptions(kind) {
    return options[kind];
  },
};



/** WEBPACK FOOTER **
 ** ./src/helpers/stepKind.js
 **/